import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Adaptations from './components/Adaptations';
import Testimonials from './components/Testimonials';
import Plans from './components/Plans';
import HowItWorks from './components/HowItWorks';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <About />
        <Adaptations />
        <Testimonials />
        <Plans />
        <HowItWorks />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;